import { createComponent as t } from "@lit/react";
const r = ({
  defineCustomElement: e,
  ...o
}) => (typeof e < "u" && e(), t(o));
export {
  r as createComponent
};
//# sourceMappingURL=runtime.js.map
